<template lang="pug">
    div(class="notifier")
        div(v-for="(message, index) in localMessagesList")
            v-alert(v-model="message.visibility"
                    dense
                    dismissible
                    @click="dismissAlert(index)"
                    :type="message.priority") {{message.message}}
</template>

<script>
import { app_logs, app_log } from './../js/app_log'

const priority_dict = new Map([[2, "success"],
                                [3, "info"],
                                [1, "warning"],
                                [0, "error" ]]);

export default {
    mixins: [app_log],
    data() {
        return {
            logger: app_logs.logs.message_queue,
            localMessagesList: []
        }
    },

    methods: {
        dismissAlert(index) {
            this.localMessagesList.splice(index, 1)
            // bloody hack for bloody bug:
            for(var el of this.$children) {
                el.$data.isActive = true;
            }
        }
    },

    watch: {
        logger: function() {
            const lastMessages = this.getUnreadLogs()
            if (lastMessages === []) {
                return []
            }
            for(const lastMessage of lastMessages) {
                const local_prio = priority_dict.get(lastMessage.priority);
                this.localMessagesList.push({
                    m_id: lastMessage.m_id,
                    visibility: true,
                    message: lastMessage.message,
                    priority: local_prio,
                    dismissSecs: 10,
                    dismissCountDown: 0
                });
            }
            setTimeout(()=>{ this.dismissAlert(this.localMessagesList.length-1, 1) }, 5000);  // 5 secs
        },
    }
}
</script>


<style>
.notifier{
    z-index: 99999;
    position: fixed;
    bottom: 0;
    right: 0;
    padding: 10px;
    border-radius: 10px
}
</style>
